import { Injectable, inject } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Location } from '@shared';

import { ProblemInstanceService } from '../problem-instance/problem-instance.service';

@Injectable({
    providedIn: 'root'
})
export class RoutePlanningService {
    private readonly problemInstanceService = inject(ProblemInstanceService);

    private readonly employeeTaskUpdateChanged$: Subject<boolean>;

    constructor() {
        this.employeeTaskUpdateChanged$ = new Subject();
    }

    public getEmployeeTaskUpdateStateChange(): Observable<boolean> {
        return this.employeeTaskUpdateChanged$.asObservable();
    }

    public employeeTaskUpdateStateChanged(updating: boolean): void {
        this.employeeTaskUpdateChanged$.next(updating);
    }

    public getOfficeLocation(): Observable<Location> {
        return this.problemInstanceService.getProblemInstance().pipe(
            map(result => {
                return <Location>{
                    latitude: result.problemInstance.officeInfo.latitude,
                    longitude: result.problemInstance.officeInfo.longitude
                };
            })
        );
    }
}
